<br>
<div class="container-fluid ">
    <div class="user-profile">
      <div class="row">
        <!-- user profile first-style start-->
        <div class="col-6" style="text-align: start;">
          <h5 class="pb-2">تفاصيل المنظمة الاهلية</h5>
      </div>
        <div class="col-sm-12">
          <div class="card hovercard text-center">
         
            <div class="user-image">
              <div class="avatar">
                <!-- <img alt="Risk Logo" src="../../../../assets/Risk Logo 200 x 200/Risk-Logo-200-x-200.png"> -->
                <img alt="Risk Logo" src="../../../../assets/Risk Logo 200 x 200/Ekram Logo 200 x 200.png">
                <!-- <img alt="Risk Logo" src="../../../../assets/Risk Logo 200 x 200/Risk-Logo-200-x-200-02.png"> -->
  
              </div>
              <!-- <div class="icon-wrapper"><i class="icofont icofont-pencil-alt-5"><input class="upload" type="file"
                     /></i></div> -->
            </div>
            <div class="info">
              <div class="row d-flex justify-content-center">
                <div class="col-lg-4 col-md-6 ">
                  <!-- <i class="icofont icofont-business-man-alt-2 fa-3x mt-2"></i> -->

                  <div >
                    <h6>الاسم: {{NGOrganizationsDetails?.name}}

                    </h6>

                  </div>

              </div>
                <div class="col-lg-4 col-md-6">
                  <div >
                    <h6> المحافظه : {{NGOrganizationsDetails?.governorateTitle}} 
  
                    </h6>
  
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div >
                    <h6>المدينه: {{NGOrganizationsDetails?.cityTitle}} 
                    </h6>
                  </div>
                </div>
              
              </div>
              <div class="row d-flex justify-content-center mt-5">
                <div class="col-lg-4 col-md-6 mb-3">
                  <div  >
                    <h6> نطاق العمل : {{NGOrganizationsDetails?.workDomain}}
                    </h6>
                  </div>
                </div>
            
                <div class="col-lg-4 col-md-6 ">
                  <div  >
                    <h6> رقم الاشهار : {{NGOrganizationsDetails?.publicationNo}}
                    </h6>
  
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-3 ">
                  <div >
                    <h6> سنة الاشهار : {{NGOrganizationsDetails?.publicationYear}}
                    </h6>
                  </div>
                </div>
              </div>
             
              
            </div>
            <div class="row text-center mt-5">
              <div class="col-lg-4 col-md-6">
                <div >
                  <h6> اسم المسؤول عن التواصل : {{NGOrganizationsDetails?.contactPersonName}}
                  </h6>

                </div>
              </div>
               <div  class="col-lg-4 col-md-6">
                <div >
                  <h6> رقم المسؤول عن التواصل : {{NGOrganizationsDetails?.phoneNumer}}
                   </h6>
                  
                </div>
              </div>
             
              <div class="col-lg-4 col-md-6 mb-3">
                <div  >
                  <h6> رابط صفحه الفيس بوك : <a href="{{NGOrganizationsDetails?.facebookPageLink}}" target="_blank" rel="noopener noreferrer">
                    <br>
                    {{NGOrganizationsDetails?.facebookPageLink}}</a>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- user profile first-style start-->

    <div class="col-sm-12">
        <div class="card hovercard text-center">                                                                                                                                        
            <div class="info">
                <div class="row">
                    <div class="col-sm-12">
                      <div class="card">
                         <div class="row"  style=" padding: 30px;">
                           <div   style="width: 2%;" class="col-4 text-center  mt-3">
                          
                            <div class="image-area text-center bg-white"  style="margin: 8px; "  >
                              <img class="imgDiv" *ngIf="situationReconcileImageEx!='pdf'"   [src]="situationReconcileImage"  height="200" width="200"  (click)="OpenImage(situationReconcileImage)">
                              <img class="imgDiv"  *ngIf="situationReconcileImageEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(situationReconcileImage)">

                              <br>
                              
                              <!-- <p style="font-size: medium;">
                                {{item.title}}</p> -->
                                <!-- <pdf-viewer [src]="electronicCard"
                                [render-text]="true"
                                [original-size]="false"
                                style="width: 400px; height: 500px"
                    ></pdf-viewer> -->
                            </div>
                            <label style="color: #4da3ba;
                            font-weight: bolder;">قرار توفيق الأوضاع</label>
                           </div>
          
                           <div   style="width: 2%;" class="col-4  text-center  mt-3">
      
                              <div class="image-area text-center bg-white" style="margin: 8px;"  >
                                <img class="imgDiv" *ngIf="systemRegulationsEx!='pdf'"    [src]="systemRegulations"  height="200" width="200"  (click)="OpenImage(systemRegulations)">
                                <img  class="imgDiv" *ngIf="systemRegulationsEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(systemRegulations)">

                                <br>
                                <!-- <p style="font-size: medium;">
                                  {{item.title}}</p> -->
            
                              </div>
                              <label style="color: #4da3ba;
                              font-weight: bolder;">صورة من لائحة النظام الأساسى</label>
                             </div>
                             <div   style="width: 2%;" class="col-4 text-center mt-3">
                              <div class="image-area text-center bg-white" style="margin: 8px;"  >
                                <img  class="imgDiv" *ngIf="trusteesBoardCertifiedStatementEx!='pdf'"  [src]="trusteesBoardCertifiedStatement"  height="200" width="200"  (click)="OpenImage(trusteesBoardCertifiedStatement)">
                                <img  class="imgDiv" *ngIf="trusteesBoardCertifiedStatementEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(trusteesBoardCertifiedStatement)">

                                <br>
                                <!-- <p style="font-size: medium;">
                                  {{item.title}}</p> -->
            
                              </div>
                              <label style="color: #4da3ba;
                              font-weight: bolder;">كشف معتمد من مجلس الامناء</label>
                                
                               </div>
                             <div   style="width: 2%;" class="col-4  text-center  mt-3">
                              <div class="image-area text-center bg-white" style="margin: 8px;"  >
                                <img class="imgDiv"  *ngIf="certifiedApplication!='pdf'"  [src]="certifiedApplication"  height="200" width="200"  (click)="OpenImage(certifiedApplication)">
                                <img  class="imgDiv" *ngIf="certifiedApplicationEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(certifiedApplication)">

                                <br>
                                <!-- <p style="font-size: medium;">
                                  {{item.title}}</p>
             -->
                              </div>
                              <label style="color: #4da3ba;
                              font-weight: bolder;">طلب معتمد للمشاركة</label>
                            
                             </div>
          
                             <div   style="width: 2%;" class="col-4  text-center mt-3 ">
                              <div class="image-area text-center bg-white" style="margin: 8px;"  >
                                <img  class="imgDiv" *ngIf="publicationCertificateEx!='pdf'"  [src]="publicationCertificate"  height="200" width="200"  (click)="OpenImage(publicationCertificate)">
                                <img  class="imgDiv" *ngIf="publicationCertificateEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(publicationCertificate)">

                                <br>
                                <!-- <p style="font-size: medium;">
                                  {{item.title}}</p> -->
            
                              </div>
                              <label style="color: #4da3ba;
                              font-weight: bolder;">قرار الاشهار</label>
                            
                             </div>
                             <div   style="width: 2%;" class="col-4  text-center mt-3 ">
                            
                              <div class="image-area text-center bg-white" style="margin: 8px;"  >
                                <img  class="imgDiv" *ngIf="otherImageEx!='pdf'"  [src]="otherImage"  height="200" width="200"  (click)="OpenImage(otherImage)">
                                <img  class="imgDiv" *ngIf="otherImageEx=='pdf'"  src="../../../../assets/images/pdfImage.png"  height="200" width="200"  (click)="OpenPdf(otherImage)">

                                <br>
                                <!-- <p style="font-size: medium;">
                                  {{item.title}}</p> -->
            
                              </div>
                              <label style="color: #4da3ba;
                              font-weight: bolder;"> صوره اخري </label>
                             </div>

                             
                         </div>
            
          </div>
                  </div>
                  </div>
           
          </div>
    </div>
  </div>